import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    userInfo: {},
    tabStatus: 1,
    gid: 0,
    ludoGid: 0,
    welfareLang: {
      zh: {
        title: '福利中心',
        gt: '游戏任务',
        dt: '每日任务',
        day: '任务',
        recharge: '充值',
        get: '领取',
        done: '已完成',
        noDone: '未完成',
        go: '去完成',
        rw: '充值福利',
        draw: '抽奖',
        dr: '每日充值',
        drawDesc: '以上任务各完成一次即可抽奖',
        rwsend: '奖励发放',
        hadGet: '今天已领取过，明天再来',
        getSuc: '领取成功',
        tdone: '任务已完成',
        tundone: '任务未完成',
        noDraw: '次数不足，无法抽奖'
      },
      en: {
        title: 'Task Center',
        gt: 'Game Tasks',
        dt: 'Daily Tasks',
        day: 'Task',
        recharge: 'Recharge',
        get: 'Get',
        done: 'Done',
        noDone: 'Undone',
        go: 'GO',
        rw: 'Recharge Task',
        draw: 'Lucky draw',
        dr: 'Daily recharge',
        drawDesc: 'Complete the above tasks once to draw',
        rwsend: 'Reward distribution',
        hadGet: 'Received it today, come back tomorrow',

        getSuc: 'Received successfully',
        tdone: 'Task completed',
        tundone: 'Task not completed',
        noDraw: 'Insufficient number of times, unable to draw prizes'
      },
      ar: {
        title: 'مركز رعاية',
        gt: 'مهمة اللعبة',
        dt: 'مهام يومية',
        day: 'مهمة ',
        recharge: 'تعبئة رصيد',
        get: 'يستلم',
        done: 'مكتمل',
        noDone: 'التراجع',
        go: 'استلم',
        rw: 'فوائد إعادة الشحن',
        draw: 'عجلة الحظ',
        dr: 'إعادة الشحن اليومي',
        drawDesc: 'أكمل كل من المهام المذكورة أعلاه مرة واحدة وستتمكن من سحب الجوائز',
        rwsend: 'ينزل الدعم',
        hadGet: 'لقد تستلمها اليوم، يرجي الاستلام غدا مرة اخرة.',

        getSuc: 'تم الاستلام',
        tdone: 'تم اكمال المهمة',
        tundone: 'لم تكمل المهمة',
        noDraw: 'عدد مرات غير كاف ولا يمكن بدأ اليانصيب.'
      },
      tr: {
        title: 'Avantajlar',
        gt: 'Oyun Görevleri',
        dt: 'Günlük Görevler',
        day: 'Görevler',
        recharge: 'Çekim Yap',
        get: 'AI',
        done: 'Alındı',
        noDone: 'Undone',
        go: 'Git',
        rw: 'Yeniden Çekim Yap',
        draw: 'Şanslı Çekiliş',
        dr: 'Günlük  Yükleme',
        drawDesc: 'Çekiliş yapmak için yukarıdaki görevleri tamamlayın.',
        rwsend: 'Reward distribution',
        hadGet: 'Received it today, come back tomorrow',

        getSuc: 'Başarılı alındı',
        tdone: 'Görev tamamlandı',
        tundone: 'Görev tamamlanmadı',
        noDraw: 'Yeterince bir kaç kez, ödülleri çizmeyecek'
      },
      jp: {
        title: '福祉センター',
        gt: 'ゲームタスク',
        dt: '毎日のタスク',
        day: 'タスク＃',
        recharge: 'Recharge',
        get: 'Get',
        done: 'Done',
        noDone: 'Undone',
        go: 'GO',
        rw: 'Recharge Task',
        draw: 'くじを引く',
        dr: '毎日チャージ',
        drawDesc: '以上のタスクを1回ずつ完了すると抽選ができます',
        rwsend: '奨励金リリース',
        hadGet: '今日受け取りましたので、明日また来ます',

        getSuc: '正常に受信されました',
        tdone: 'タスクが完了しました',
        tundone: 'タスクが完了していません',
        noDraw: '回数が足りず抽選できない'
      },
      ru: {
        title: 'Центр заданий',
        gt: 'Игровые задания',
        dt: 'Ежедневные задания',
        day: 'Задание',
        recharge: 'Пополнение',
        get: 'Получить',
        done: 'Выполнено',
        noDone: 'Не выполнено',
        go: 'ВПЕРЁД',
        rw: 'Задание на пополнение',
        draw: 'Лотерея',
        dr: 'Ежедневное пополнение',
        drawDesc: 'Выполните указанные задания один раз для участия в розыгрыше',
        rwsend: 'Распределение наград',
        hadGet: 'Сегодня уже получено, возвращайтесь завтра',

        getSuc: 'Успешно получено',
        tdone: 'Задание выполнено',
        tundone: 'Задание не выполнено',
        noDraw: 'Недостаточно попыток, невозможно получить приз'
      },
      id: {
        title: 'Pusat Tugas',
        gt: 'Tugas Game',
        dt: 'Tugas Harian',
        day: 'Tugas',
        recharge: 'Isi Ulang',
        get: 'Dapatkan',
        done: 'Selesai',
        noDone: 'Belum Selesai',
        go: 'MULAI',
        rw: 'Tugas Isi Ulang',
        draw: 'Undian Berhadiah',
        dr: 'Isi Ulang Harian',
        drawDesc: 'Selesaikan tugas di atas sekali untuk mengundi',
        rwsend: 'Distribusi Hadiah',
        hadGet: 'Sudah diterima hari ini, kembali besok',
        getSuc: 'Berhasil diterima',
        tdone: 'Tugas selesai',
        tundone: 'Tugas belum selesai',
        noDraw: 'Jumlah tidak cukup, tidak bisa mengundi hadiah'
      },
      pt: {
        title: 'Central de Tarefas',
        gt: 'Tarefas de Jogo',
        dt: 'Tarefas Diárias',
        day: 'Tarefa',
        recharge: 'Recarregar',
        get: 'Obter',
        done: 'Concluído',
        noDone: 'Não Concluído',
        go: 'IR',
        rw: 'Tarefa de Recarga',
        draw: 'Sorteio',
        dr: 'Recarga Diária',
        drawDesc: 'Complete as tarefas acima uma vez para sortear',
        rwsend: 'Distribuição de Recompensas',
        hadGet: 'Recebido hoje, volte amanhã',
        getSuc: 'Recebido com sucesso',
        tdone: 'Tarefa concluída',
        tundone: 'Tarefa não concluída',
        noDraw: 'Número insuficiente de vezes, não é possível sortear prêmios'
      },
      fa: {
        title: 'مرکز وظایف',
        gt: 'وظایف بازی',
        dt: 'وظایف روزانه',
        day: 'وظیفه',
        recharge: 'شارژ',
        get: 'دریافت',
        done: 'انجام شده',
        noDone: 'انجام نشده',
        go: 'برو',
        rw: 'وظیفه شارژ',
        draw: 'قرعه کشی',
        dr: 'شارژ روزانه',
        drawDesc: 'وظایف بالا را یک بار کامل کنید تا قرعه کشی کنید',
        rwsend: 'توزیع جایزه',
        hadGet: 'امروز دریافت شده است، فردا برگردید',
        getSuc: 'با موفقیت دریافت شد',
        tdone: 'وظیفه تکمیل شد',
        tundone: 'وظیفه تکمیل نشد',
        noDraw: 'تعداد دفعات کافی نیست، قادر به قرعه کشی جایزه نیست'
      },
      ur: {
        title: 'ٹاسک سینٹر',
        gt: 'گیم ٹاسکس',
        dt: 'روزانہ ٹاسکس',
        day: 'ٹاسک',
        recharge: 'ریچارج',
        get: 'حاصل کریں',
        done: 'مکمل',
        noDone: 'نامکمل',
        go: 'جاؤ',
        rw: 'ریچارج ٹاسک',
        draw: 'خوش قسمتی ڈرا',
        dr: 'روزانہ ریچارج',
        drawDesc: 'اوپر کے ٹاسکس ایک بار مکمل کرکے ڈرا کریں',
        rwsend: 'انعام کی تقسیم',
        hadGet: 'آج مل چکا ہے، کل دوبارہ آئیں',
        getSuc: 'کامیابی سے حاصل ہوا',
        tdone: 'ٹاسک مکمل ہوگیا',
        tundone: 'ٹاسک مکمل نہیں ہوا',
        noDraw: 'ڈرا کرنے کے لیے کوششوں کی تعداد ناکافی'
      },
      uz: {
        title: 'Vazifalar Markazi',
        gt: 'Oʻyin Vazifalari',
        dt: 'Kunlik Vazifalar',
        day: 'Vazifa',
        recharge: 'Toʻldirish',
        get: 'Olish',
        done: 'Bajarildi',
        noDone: 'Bajarilmadi',
        go: 'BOSHLASH',
        rw: 'Toʻldirish Vazifasi',
        draw: 'Omadli Chiziq',
        dr: 'Kunlik Toʻldirish',
        drawDesc: 'Yuqoridagi vazifalarni bir marta bajarib chizing',
        rwsend: 'Mukofot Taqsimoti',
        hadGet: 'Bugun olindi, ertaga qaytib keling',
        getSuc: 'Muvaffaqiyatli qabul qilindi',
        tdone: 'Vazifa bajarildi',
        tundone: 'Vazifa bajarilmadi',
        noDraw: 'Urinishlar yetarli emas, sovgʻalarni olish imkonsiz'
      }
    },
    userLang: {
      zh: {
        nw: '新用户福利',
        get: '领取',
        go: '去完成',
        cSuc: '创建房间成功，快去邀请好友聊天吧！',
        rExi: '房间已存在！',
        getSuc: '领取成功',
        hadGet: '已领取',
        undone: '任务未完成',
        done: '任务已完成',
        allDone: '完成以下全部任务即可领取',
        newUser: '新用户7天内可领取',
        more: '更多奖励'
      },
      en: {
        nw: 'New User Task',
        get: 'Get',
        go: 'GO',
        cSuc: 'Successfully created the room, go and invite friends to chat!',
        rExi: 'Room already exists!',
        getSuc: 'Received successfully',
        hadGet: 'Received',
        undone: 'Task not completed',
        done: 'Task completed',
        allDone: 'Complete all tasks to receive rewards',
        newUser: 'New users can claim it within 7 days',
        more: 'More Reward'
      },
      ar: {
        nw: 'المكافاة للمستخدم الجديد',
        go: 'GO',
        get: 'يستلم',
        cSuc: 'انشاء الغرفة نجاحا، لتدعو اصدقائك اليها لدردشة.',
        rExi: 'الغرفة موجودة',
        getSuc: 'تم الاستلام',
        hadGet: 'استلمت',
        undone: 'لم تكمل المهمة',
        done: 'تم اكمال المهمة',
        allDone: 'يمكن الاستلام بعد اكمال جميع المهمات التالية',
        newUser: 'يمكن الاستلام عند المستخدم الجديد من غضون سبعة ايام',
        more: 'المزيد من المكافآت'
      },
      tr: {
        nw: 'Görev Merkezi',
        get: 'AI',
        go: 'Git',
        cSuc: 'Odayı başarıyla yarattı, gidip arkadaşları konuşmaya davet et!',
        rExi: 'Oda zaten var!',
        getSuc: 'Başarılı alındı',
        hadGet: 'Alındı',
        undone: 'Görev tamamlanmadı',
        done: 'Görev tamamlandı',
        allDone: 'Ödülleri almak için tüm görevleri tamamlayın',
        newUser: 'Yeni kullanıcılar 7 gün içinde bunu iddia edebilirler.',
        more: 'More Reward'
      },
      jp: {
        nw: '新規ユーザー福利厚生',
        get: 'Get',
        go: 'GO',
        cSuc: '部屋の作成に成功しました。早く友達を誘って話しましょう。',
        rExi: '部屋は既に存在します！',
        getSuc: '受け取り成功',
        hadGet: '受領済',
        undone: 'タスクが完了していません',
        done: 'タスクが完了しました',
        allDone: 'すべてのタスクを完了すると報酬が得られます',
        newUser: '新規ユーザーは7日以内に受け取ることができます',
        more: 'その他の福利厚生'
      }
    }
  }

  @action async GetUserInfoWeb(uid) {
    let resParams = await http.post('/web/MyAccountInfo', { uid: uid })
    this.data.userInfo = resParams.res
    return resParams
  }

  @action setTabStatus(status) {
    this.data.tabStatus = status
  }

  /**
   * @description 每日任务列表
   * @returns
   */
  @action async apiGetDailyTasksList() {
    let data = await http.post('/web/dailyTask/list', { type: 3 })
    return data
  }

  /**
   * @description 游戏任务列表
   * @returns
   */
  @action async apiGetGameTasksList() {
    let data = await http.post('/web/dailyTask/list', { type: 2 })
    return data
  }

  /**
   * @description 领取每日任务奖励
   * @returns 0成功 1已经领取过不能领取  2未完成
   */
  @action async getDailyTasksReward(taskid) {
    let data = await http.post('/web/dailyTask/get', { taskid })
    return data
  }

  /**
   * @description 创建房间
   * @returns 0成功，非0失败
   */
  @action async apiCreateRoom() {
    let data = await http.post('/web/group/create')
    return data
  }

  /**
   * @description 随机获取排名前30的房间id
   * @returns 房间id
   */
  @action async getRandomTopThirty() {
    let result = await http.post('/web/top30/gid')
    if (result && result.code == 0 && result.res) {
      this.data.gid = result.res
      // return result && result.res
    // } else {
      // return result
    }
  }

  /**
   * @description 随机正在进行ludo的房间
   * @returns 房间id
   */
  @action async randomLudoGid() {
    let result = await http.post('/web/dailyTask/ludo/gid')
    if (result && result.code == 0) {
      this.data.ludoGid = result.res
      // return result && result.res
    // } else {
      // return result
    }
  }

  /**
   * @description 随机获取麦位存在在线用户的gid
   * @returns 房间id
   */
  @action async getRandomOnlineMic() {
    let result = await http.post('/web/on/mic/gid')
    if (result && result.code == 0) {
      return result && result.res
    } else {
      return result
    }
  }

  /**
   * @description 新人任务列表
   * @returns isAllCompleted：0未完成不可领取 1可以领取 2已领取，status: 0未完成 1已完成
   */
  @action async apiGetNewUserTaskList() {
    let data = await http.post('/web/dailyTask/new/user/list')
    return data
  }

  /**
   * @description 领取新人福利
   * @returns res: 0领取成功  1已经领取过  2未完成不可领取
   */
  @action async getNewUserWelfareReward() {
    let data = await http.post('/web/dailyTask/new/user/welfare/get')
    return data
  }

  /**
   * @description 新人福利列表
   * @returns
   */
  @action async apiGetNewUserWelfareList() {
    let data = await http.post('/web/dailyTask/new/user/welfare/list')
    return data
  }

  /**
   * @description 抽奖
   * @returns
   */
  @action async apiDrawReward(type) {
    let data = await http.post('/web/dailyTask/lottery', { type })
    return data
  }

  /**
   * @description 抽奖次数
   * @returns
   */
  @action async getDrawCount(type) {
    let data = await http.post('/web/dailyTask/lottery/count', { type })
    return data
  }
}



// WEBPACK FOOTER //
// src/store/activity/welfare.js